export default __webpack_public_path__ + "static/media/aol-logo.46976d56.svg";